<template>
    <div class="reserve-confirm">
        <div class="mb-4 text-end">
            <button @click="toggleCancelDisp" v-if="cancel_disp" class="bscBtn">
                {{ word_chg('キャンセルした予約を表示させない') }}
            </button>
            <button @click="toggleCancelDisp" v-else class="bscBtn">
                {{ word_chg('キャンセルした予約を表示する') }}
            </button>
        </div>
        <!-- {{ reservation_node }} -->
        <ul class="reserve-confirm__list" v-if="reservations.length > 0">
            <li class="reserve-confirm__lists" v-for="node in reservations" :key="node">
                <p class="reserve-confirm__item d-flex align-items-center">
                    <span class="reserve-confirm__icon reserve-confirm__icon--red" v-if="node.is_cancel ==0">{{ word_chg('予約済')}}</span>
                    <span class="reserve-confirm__icon reserve-confirm__icon--red" v-else-if="node.is_cancel ==1">{{ word_chg('キャンセル')}}</span>
                    <span class="reserve-confirm__category">{{ node.category_group_label }}</span>
                    <a href="#" class="reserve-confirm__icon text-dark" @click="detailToggle(node)">
                        -{{ word_chg('詳細')}}-
                    </a>
                </p>
                <p class="reserve-confirm__description">
                    {{ node.start_date_str }} {{ youbi(node) }}<br>
                    {{ word_chg('チェックイン')}} : {{ get_ledger_value_by_reserved_type(node, 'checkin_date') }}<br>
                    {{ word_chg('チェックアウト')}} : {{ get_ledger_value_by_reserved_type(node, 'checkout_date') }}
                </p>
                <p class="reserve-confirm__description" v-if="node.detail_disp_sw">
                    <table class="table table-bordered">
                        <tbody>
                            <tr>
                                <td style="font-size:90%;font-weight: normal;">{{ word_chg('ご予約者') }}</td>
                                <td>{{ node.reservation_m_label }}</td>
                                <td style="font-size:90%;font-weight: normal;">宿泊人数</td>
                                <td class="text-end">{{ get_count_guests_by_reserved(node) }}</td>
                            </tr>
                            <tr>
                                <td style="font-size:90%;font-weight: normal;"></td>
                                <td></td>
                                <td style="font-size:90%;font-weight: normal;">宿泊料金</td>
                                <td class="text-end">¥{{ number_format(get_price_by_reserved(node)) }}</td>
                            </tr>
                        </tbody>
                    </table>
                </p>
            </li>
        </ul>
        <div v-else-if="load_finish">
            {{ word_chg('予約はありません。') }}
        </div>
        <div v-else>
            {{ word_chg('読み込み中') }}
        </div>
    </div>

</template>

<style scoped>
    .bscBtn {
        display:inline-block;padding:.7501875469rem 1.200300075rem;border:1px solid #646464;background:#e6e6e6;border-radius:.5626406602rem;color:#646464;font-size:1.5003750938rem;font-weight:normal;line-height:1em;letter-spacing:.05em;text-decoration:none
    }
</style>
<script>
// import BsPageTitle from '../molecules/BsPageTitle.vue'
import { mapState } from 'vuex';
import moment from 'moment'
import config from '../../../const'
import axios from 'axios'
import Common from '../../../common/common'
export default {
    name: 'ListReservedView',
    data: function () {
        return {
            reservation_node: [],
            load_finish: false,
            page: 0,
            pagelimit: 8,
            pager_obj: {},
            cancel_disp: false
        }
    },
    props: {
        // displayClass: {
        //     type: String,
        //     default: 'col-md-9 ms-sm-auto col-lg-10 px-md-4'
        // },
    },
    components: {
        // BsPageTitle,
    },
    methods: {
        toggleCancelDisp(){
            if(this.cancel_disp){
                this.cancel_disp = false;
            }else{
                this.cancel_disp = true;
            }
            this.pageAction(0);
        },
        pageAction(page){
            console.log('pageAction', page);
            this.page = page;
            this.loadReservationNode();
        },
        cancelConfirm(target){
            if(window.confirm(this.word_chg('キャンセルします。よろしいですか？'))){
                this.cancelAction(target);
                // return;
            }
            else{
                return;
            }
        },
        cancelAction(target) {
            const param = {};
            param['is_cancel'] = 1;

            param['id'] = target;

            return this.$store.dispatch('updateBasic', {data: param, target: 'reservation_node' })
            .then((response) => {
                // this.back()
                if(response){
                    alert(this.word_chg('キャンセルしました'));
                }
            })
            .catch(
                () => {
                err => Promise.reject(err);
                alert(this.word_chg('キャンセルできませんでした'));
                }
            )
            .finally(async ()=>{
                await this.loadReservationNode();
        // await this.loadReservationNodeU();
        // await this.loadReservationNodeR();
            })
        },
        detailToggle(node){
            node.detail_disp_sw = (node.detail_disp_sw)? false: true;
            // const tmps = this.reservation_node;
            // const nodeIndex = tmps.findIndex(nd => {
            //     return nd.id == node_id; 
            // });
            // if(nodeIndex){
            //     tmps[nodeIndex].detail_disp_sw = (tmps[nodeIndex].detail_disp_sw)? false: true;
            // }
            // this.reservation_node = tmps;
            // this.$forceUpdate();
            
            // node.detail_disp_sw = (node.detail_disp_sw)? false: true;
        },
        async loadReservationNode () {
            const params = {};
            params['type'] = 'lodge';
            params['use_m_id'] = this.$store.state.auth.userId;
            params['stat'] = [1];
            if(!this.cancel_disp){
                params['is_cancel'] = 0;
            }
            params['pageorder'] = "range_start_date";
            params['pagesort'] = 'ASC';
            params['pagelimit'] = this.pagelimit;
            if(this.page >= 0) params['p'] = this.page;

            const params_ = Common.createParams(params);
            axios.post(
                config.BASE_API_URL + '/reservation_node/lists',
                params_,
                {
                headers: this.axiosHeader
                }
            )
            .then(
                (response) => {
                    console.log('loadReservationNode response', response);
                    this.reservation_node = (response && response.data && typeof response.data === 'object' && typeof response.data.body === 'object')? response.data.body: [];
                    this.pager_obj = (response && response.data && typeof response.data === 'object' && typeof response.data.pager === 'object')? {reservation_node: response.data.pager}: {};
                }
            )
            .catch((err) => {
                console.log('loadDashboard err c', err);
                // this.search_sales = [];
                this.reservation_node = [];
            })
            .finally(() => {
                this.$forceUpdate();
            });
            // params['end_date'] = moment().format('YYYY-MM-DD');
            // return this.$store.dispatch('fetchBasicLists', {data: params, target: 'reservation_node'})
            //             .catch(err => Promise.reject(err))
            //             .then(() => {
            //                 console.log('loard complete reservation_node');
            //                 console.log('this', this.$store.state.apidata.reservation_node);
            //             })
            //             .finally(() => {
            //                 console.log('finally', this.$store.state.apidata.reservation_node);
            //             })
        },
        async loadFinish(){
            this.load_finish = true;
        },
    },
    computed: {
        ...mapState({
            reservation_node: state => state.apidata.reservation_node,
            // paddock_list: state => state.apidata.drive_node_category,
        }),
        youbi: function (){
            return function(node){
                return moment(node.start_date_str).format("ddd");
            }
        },
        reservations: function(){
            // const tmps_node = [...this.reservation_node_u, ...this.reservation_node_r];
            const tmps_node = [...this.reservation_node];
            if(Object.keys(tmps_node).length > 0){
                const ttt = tmps_node.map(node => {
                    node.detail_disp_sw = false;
                    return node;
                });

                ttt.sort((a, b) => {
                    if(parseInt(a.range_start_date) > parseInt(b.range_start_date)){
                        return 1;
                    }else{
                        return -1;
                    }
                });
                return ttt;
            }
            return [];
        },
        axiosHeader: function(){
            return {[config.BASE_API_HEADER_KEY]: this.$store.state.auth.token};
        },
        get_ledger_by_reserved: function(){
            return function(reserved){
                if(
                    typeof reserved === 'object' && typeof reserved.ledger_data === 'object' 
                ){
                    const tmps = [];
                    Object.values(reserved.ledger_data).forEach(ledgers => {
                        if(
                            typeof ledgers === 'object'
                        ){
                            Object.values(ledgers).forEach(ledger => {
                                tmps.push(ledger);
                            })
                        }
                    })
                    return tmps;
                }
                return false;
            }
        },
        get_ledger_value_by_reserved_type: function(){
            const func = this.get_ledger_by_reserved;
            return function(reserved, type_id){
                const ledger_data = func(reserved);
                if(
                    typeof ledger_data === 'object' && ledger_data.find(ledger => {
                        if(typeof ledger.sel_ledger === 'object' && typeof ledger.sel_ledger.relation_column === 'string' && ledger.sel_ledger.relation_column == type_id){
                            return true;
                        }
                        else{
                            return false;
                        }
                        // return ledger.sel_ledger.relation_column == type_id
                    })
                ){
                    const findex =  ledger_data.findIndex(ledger => {return ledger.sel_ledger.relation_column == type_id});
                    if(typeof ledger_data[findex] === 'object' && ledger_data[findex].value){
                        return ledger_data[findex].value;
                    }
                }
                else if(
                    typeof ledger_data === 'object' && ledger_data.find(ledger => {return ledger.type_id == type_id})
                ){
                    const findex =  ledger_data.findIndex(ledger => {return ledger.type_id == type_id});
                    if(typeof ledger_data[findex] === 'object' && ledger_data[findex].value){
                        return ledger_data[findex].value;
                    }
                }
                return '';
            }
        },
        get_price_by_reserved(){
            const getRoomPrice = this.getRoomPrice;
            const getLedgerPrice = this.getLedgerPrice;
            const getServicePrice = this.getServicePrice;
            const getLedgerBathingTax = this.getLedgerBathingTax;
            const getVaTax = this.getVaTax;
            return function(node){
                const room_price = getRoomPrice(node);
                const ledger_price = getLedgerPrice(node);
                const service_price = getServicePrice(node);
                const bathing_tax = getLedgerBathingTax(node);
                const va_tax = getVaTax(node);
                return parseInt(room_price) + parseInt(ledger_price) + parseInt(service_price) + parseInt(bathing_tax) + parseInt(va_tax);
            }
        },
        get_count_guests_by_reserved(){
            const get_func = this.get_ledger_value_by_reserved_type;
            return function(node){
                const male = get_func(node, 'adult_male');
                const female = get_func(node, 'adult_female');
                const child = get_func(node, 'child_teen');
                return parseInt(male) + parseInt(female) + parseInt(child);
            }
        },
        get_count_guests_adult_by_reserved(){
            const get_func = this.get_ledger_value_by_reserved_type;
            return function(node){
                const male = get_func(node, 'adult_male');
                const female = get_func(node, 'adult_female');
                return parseInt(male) + parseInt(female);
            }
        },
        getVaTax(){
            const getRoomPrice = this.getRoomPrice;
            const getLedgerPrice = this.getLedgerPrice;
            const getServicePrice = this.getServicePrice;
            return function(node){
                const totalPrice = getRoomPrice(node) + getLedgerPrice(node) + getServicePrice(node);
                return (totalPrice > 0)? Math.floor(totalPrice * 0.1): 0;
            }
        },
        getServicePrice(){
            const get_func = this.getRoomPrice;
            return function(node){
                const roomPrice = get_func(node);
                return (roomPrice > 0)? Math.floor(roomPrice * 0.1): 0;
            }
        },
        getRoomPrice:function(){
            return function(node){
                return parseInt(node.reserve_price);
            }
        },
        getLedgerPrice:function(){
            const get_func = this.get_ledger_by_reserved;
            return function(node){
                let sum_price = 0;
                const mledgers = get_func(node);
                if(
                    typeof mledgers === 'object'
                    && Object.keys(mledgers).length > 0
                ){
                    Object.values(mledgers).forEach(mledger => {
                        if(mledger.type_id > 0 && mledger.value != ''){
                            const ltype = (typeof mledger.sel_ledger === 'object')? 
                                mledger.sel_ledger: false;
                                console.log('getLedgerPrice', mledger.sel_ledger);
                            if(
                                ltype !== false 
                                && typeof ltype === 'object' 
                                && ltype.default_param !== null 
                                && typeof ltype.default_param === 'object'
                            ){
                                const dp = Object.values(ltype.default_param).filter((value) => {
                                    if(value.key == mledger.value) return value;
                                });
                                if(dp && typeof dp === 'object' && dp[0] && dp[0].price > 0){
                                    sum_price += parseInt(dp[0].price);
                                }
                            }
                        }
                    });
                }
                // member.price = sum_price;
                return sum_price;
            }
        },
        getLedgerBathingTax:function(){
            const get_func = this.get_count_guests_adult_by_reserved;
            return function(node){
                console.log('getLedgerBathingTax');
                const adult_cnt = get_func(node);
                return parseInt(adult_cnt) * 150;
            }
        },
    },

    async created () {
        await this.loadReservationNode();
        // await this.loadReservationNodeU();
        // await this.loadReservationNodeR();
        await this.loadFinish();
        // this.loaddriveNode();
        // this.loadLedgerType();
    },
}
</script>
